/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: telephonyDomainsActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the telephonyDomains module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { deleteDomain } from './api/telephonyDomainsApi';

/**
 * Shared helpers for Telephony Domains module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Telephony Domain in the form.
 * Pattern: /admin/multi-tenant/domains/new?duplicate={id}
 */
export const getTelephonyDomainDuplicateUrl = (id: string | number): string =>
  `/admin/multi-tenant/domains/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Telephony Domain id.
 */
export const navigateToTelephonyDomainDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getTelephonyDomainDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Telephony Domain by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 */
export const deleteTelephonyDomainById = async (
  id: string | number,
  tenantSlug: string,
  userId?: string | number | null,
): Promise<void> => {
  await deleteDomain(String(id), tenantSlug, userId?.toString());
};

